<template>
    <div>
        <div id="header-container" class="px-5 in-step">
            <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header">
            <div class="pt-4 text-white mb-4">
                <h3 class="text-white">{{ $t('Update Partner (Different Name)') }}</h3>
                <span class="fz-16 fw-400">Fill out the form to update partner</span>
            </div>

            <step-container
                :current_step="3"
                :step_list="stepList"
            ></step-container>
        </div>

        <b-container fluid class="mt-0 pb-5">
        
            <b-row>
                <b-col cols="12" md="8" class="mx-auto">
                    <div id="body-container" v-if="bank_info">
                        <div class="p-0 pb-5 text-center">
                            <img :src="`${publicPath}/img/gep/withdrawal-icon.svg`" style="background-color: #EDF8F1;border-radius: 20px;">
                            <h5 class="my-3">Partner (Different Name)</h5>
                            <hr/>
                            <div class="d-flex mb-3">
                                <h5>Partner Info</h5>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Name</div>
                                <div class="ml-auto fw-700">{{ add_partner.name }}</div>
                            </div>

                            <div class="d-flex mb-3">
                                <div>Name - English</div>
                                <div class="ml-auto fw-700">{{ add_partner.enName }}</div>
                            </div>

                            <div class="d-flex mb-3">
                                <div>Phone Number</div>
                                <div class="ml-auto fw-700">{{ add_partner.phoneNum }}</div>
                            </div>

                            <div class="d-flex mb-3">
                                <div>Country</div>
                                <div class="ml-auto fw-700">{{ add_partner.countryName }}</div>
                            </div>

                            <div class="d-flex mb-3">
                                <div>Province</div>
                                <div class="ml-auto fw-700">{{ add_partner.province }}</div>
                            </div>

                            <div class="d-flex mb-3">
                                <div>City</div>
                                <div class="ml-auto fw-700">{{ add_partner.city }}</div>
                            </div>

                            <div class="d-flex mb-3">
                                <div>Postal Code</div>
                                <div class="ml-auto fw-700">{{ add_partner.zipCode }}</div>
                            </div>

                            <div class="d-flex mb-3">
                                <div>Address</div>
                                <div class="ml-auto fw-700">{{ add_partner.address }}</div>
                            </div>
                            <hr>
                            <div class="d-flex mb-3">
                                <h5>Bank Info</h5>
                            </div>

                            <div class="d-flex mb-3">
                                <div>Partner Type</div>
                                <div class="ml-auto fw-700">{{ bank_info.accType==1?'Business':'Individual' }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Account Currency</div>
                                <div class="ml-auto fw-700">{{ bank_info.accountCcy }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Account Name</div>
                                <div class="ml-auto fw-700">{{ bank_info.accountName }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Card Number</div>
                                <div class="ml-auto fw-700">{{ bank_info.cardNo }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Payment Channel Type</div>
                                <div class="ml-auto fw-700">{{ bank_info.paymentChannelType }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Bank Name</div>
                                <div class="ml-auto fw-700">{{ bank_info.bankName }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Bank Branch Name</div>
                                <div class="ml-auto fw-700">{{ bank_info.bankBranchName }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Bank Country</div>
                                <div class="ml-auto fw-700">{{ bank_info.countryName }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Swift Code</div>
                                <div class="ml-auto fw-700">{{ bank_info.swiftCode }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Partner Address</div>
                                <div class="ml-auto fw-700">{{ add_partner.address }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Bank Address</div>
                                <div class="ml-auto fw-700">{{ bank_info.bankAddress }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Bank code</div>
                                <div class="ml-auto fw-700">{{ bank_info.clearingCode }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Account Type</div>
                                <div class="ml-auto fw-700">{{ getCardType(bank_info.cardType) }}</div>
                            </div>
                            <hr/>
                            <div class="d-flex mb-0">
                                <button @click="$router.go(-1);" class="btn btn-previous d-block mr-auto">{{ $t('Previous') }}</button>
                                <button @click="doSubmit" class="btn btn-primary d-block">{{ $t('Submit') }}</button>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
        
      </b-container>
      <LoaderComponent v-if="isLoading"></LoaderComponent>
    </div>
  </template>
  <script>
  
    import LoaderComponent from "@/components/LoaderComponent";
    import stepContainer from "@/components/CardManagement/stepContainer";
    import Global from '@/services/Global';
    import Withdrawal from "@/services/Withdrawal";
  
    export default {
        name: 'update-partner-summary',
        data() {
            return {
                publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
                isLoading : false,
                bank_info: null,
                add_partner:null,
                stepList:["Partner Info", "Bank Info", "Partner Summary"],
            }
        },
        components: {
            LoaderComponent,
            stepContainer
        },
        methods:{
            getCardType(type){
                if(type == 10){
                    return "DEPOSIT";
                }
                else if(type == 11){
                    return "SAVING";
                }
                else{
                    return "CHECKING";
                }
            },
            getCostBorne(type){
                return this.costBorne[type];
            },
            getPurpose(type){
                return this.paymentPurposeOpt[parseInt(type)+1].text;
            },
            getAmount(amount){
                return Global.addCommas(amount);
            },
            getMessage: function (key) {
                return this.$t(key)
            },
            doSubmit(){
                let self = this;
                this.isLoading = true;
                Withdrawal.updatePartner({
                    partnerBankId:this.$route.query.id,
                    "partner":{
                        "countryCode":self.add_partner.countryCodeIso3,
                        "name":self.add_partner.name,
                        "enName":self.add_partner.enName,
                        "address":self.add_partner.address,
                        "userNo": self.bank_info.userNo
                    },
                    "partnerBank":{
                        "accType":self.bank_info.accType,
                        "accountCcy":self.bank_info.accountCcy,
                        "accountName":self.bank_info.accountName,
                        "cardNo":self.bank_info.cardNo,
                        "paymentChannelType":self.bank_info.paymentChannelType,
                        "bankName":self.bank_info.bankName,
                        "bankBranchName":self.bank_info.bankBranchName,
                        "countryCode":self.bank_info.countryCodeIso3,
                        "swiftCode":self.bank_info.swiftCode,
                        "payeeAddress":self.add_partner.address,
                        "bankAddress":self.bank_info.bankAddress,
                        "clearingCode":self.bank_info.clearingCode,
                        "cardType":self.bank_info.cardType,
                        "phoneNum":self.add_partner.phoneNum,
                        "province":self.add_partner.province,
                        "city":self.add_partner.city,
                        "zipCode":self.add_partner.zipCode
                    }
                }).then((response)=>{
                    if (response.status == 200) {
                        self.isLoading = false;
                        let data = response.data.data;
                        localStorage.removeItem('partner_update');
                        localStorage.removeItem('bank_info_update');
                        
                        self.$swal({
                            icon: 'success',
                            title: self.getMessage('Success'),
                            showConfirmButton: true,
                        }).then((result) => {
                            self.$router.push({ 
                                path: '/beneficiaries', 
                            });
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                    self.checkError(err);
                });
            },
            checkError(err){
                this.isLoading = false;
                const response = err.response;  
                console.log("===================");
                let self = this;
                if(response.status == 400){
                    console.log(response.data);
                    if(typeof response.data.message === 'string'){
                        this.$swal({
                            icon: 'info',
                            html:response.data.message,
                            showConfirmButton: true,
                            confirmButtonText: self.getMessage('OK')
                        });
                    }
                    else{
                        if(response.data.message['errorMsg']){
                            this.$swal({
                                icon: 'info',
                                html:response.data.message['errorMsg'],
                                showConfirmButton: true,
                                confirmButtonText: self.getMessage('OK')
                            });
                        }
                        else{
                            let ret = [];
                            Object.keys(response.data.message).forEach((key) => {
                                ret.push(response.data.message[key][0]);
                            });

                            this.$swal({
                                icon: 'info',
                                html:ret.join("<br>"),
                                showConfirmButton: true,
                                confirmButtonText: self.getMessage('OK')
                            });
                        }
                    }
                }      
                else if(response.status == 401 && response.data.name == "Unauthorized"){
                        localStorage.removeItem("token");
                        localStorage.removeItem("member");
                        localStorage.removeItem("isFirstTime");
                        this.$router.push({ 
                            path: '/login', 
                        });
                }
                else{
                    if(localStorage.getItem("token")){
                        var msg = (response.data)?response.data.message:err.message;
                        this.$swal({
                            icon: 'info',
                            html:msg,
                            showConfirmButton: true,
                            confirmButtonText: self.getMessage('OK')
                        });
                    }
                }
            }
        },
        mounted(){
            const savedadd_partner = JSON.parse(localStorage.getItem('partner_update'));
            const savedbank_info = JSON.parse(localStorage.getItem('bank_info_update'));
            this.add_partner = savedadd_partner;
            this.bank_info = savedbank_info;
            console.log(this.add_partner);
        }
    };
  </script>

<style scoped>
ul li{
    list-style: disc;
}
.point .number{
    background-color: rgba(103, 163, 83, 1);
    border-radius: 50%;
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 14px;
    font-size: 14px;
    padding: 3px;
    font-weight: 500;
    color: #fff;
}
.account-type:hover{
    background: linear-gradient(90deg, #00AEEF 0%, #0972D3 100%) !important;
}
.block-item{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
}
hr{
    border-style: dashed;
}
</style>